import { Quote } from "lucide-react";
import Reveal, { Eyebrow } from "./Reveal";

const stats = [
  { value: "96", label: "Non-compliance issues resolved" },
  { value: "9", label: "Months to full compliance" },
  { value: "100%", label: "Issues brought into compliance" },
];

export default function SuccessStories() {
  return (
    <section id="success-stories" className="bg-basalt py-28 lg:py-40" data-testid="success-stories-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <Eyebrow>Success stories</Eyebrow>
          <h2
            className="mt-4 max-w-4xl font-display text-2xl font-bold tracking-tight text-sand sm:text-3xl lg:text-4xl"
            data-testid="success-stories-heading"
          >
            Ninety-six citations. Nine months.{" "}
            <span className="text-ochre">Zero left standing.</span>
          </h2>
        </Reveal>

        <Reveal delay={0.12}>
          <div
            className="glass-card mt-16 grid grid-cols-1 overflow-hidden rounded-2xl lg:grid-cols-5"
            data-testid="florida-case-study"
          >
            <div className="flex flex-col justify-center border-b border-sand/10 bg-ochre p-10 lg:col-span-2 lg:border-b-0 lg:border-r lg:border-sand/10 lg:p-14">
              <span className="font-display text-7xl font-extrabold leading-none tracking-tight text-basalt lg:text-8xl">
                96
              </span>
              <span className="mt-4 font-mono text-xs uppercase tracking-[0.25em] text-basalt/70">
                Non-compliance issues — State of Florida
              </span>
            </div>
            <div className="relative p-10 lg:col-span-3 lg:p-14">
              <Quote size={40} className="absolute right-10 top-10 text-ochre/20" aria-hidden="true" />
              <p className="max-w-xl text-base leading-relaxed text-sand sm:text-lg">
                In 2019, the State of Florida was carrying{" "}
                <strong className="text-ochre">96 non-compliance issues</strong>. Our Vice President,{" "}
                <strong>Maria Lopez</strong>, led the remediation — reading the data, building the
                correction plans, and driving implementation until every single issue was brought
                into compliance. It took nine months.
              </p>
              <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-3">
                {stats.map((s) => (
                  <div key={s.label} className="rounded-xl border border-sand/10 bg-basalt/50 p-5">
                    <span className="font-display text-2xl font-extrabold text-ochre">{s.value}</span>
                    <p className="mt-2 font-mono text-[10px] uppercase leading-relaxed tracking-[0.15em] text-mist">
                      {s.label}
                    </p>
                  </div>
                ))}
              </div>
              <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.25em] text-smoke">
                State of Florida · 2019 · Led by Maria Lopez, VP &amp; Co-Founder
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
